<template>
  <v-layout align-start>
    <v-flex>
      <v-card width="100%" height="100%">
        <v-tabs color="blue accent-4" right>
          <v-btn @click="dialogNuevo()" color="primary" dark class="mt-2"
            >Nuevo</v-btn
          >
          <v-btn
            @click="obtenerDatosTelegram()"
            color="primary"
            dark
            class="mt-2 ml-2"
            >Telegram</v-btn
          >
          <v-divider vertical inset class="mx-1"></v-divider>
          <v-tab>PROVEEDORES INTERNOS Y EXTERNOS</v-tab>
          <v-tab>PROVEEDORES GUATEMALA</v-tab>
          <v-tab>PROVEEDORES HONDURAS</v-tab>
          <v-tab>PROVEEDORES NICARAGUA</v-tab>
          <v-tab>PROVEEDORES COSTA RICA</v-tab>
          <v-tab>PROVEEDORES PANAMA</v-tab>
          <v-tab-item>
            <v-container fluid class="pa-2">
              <!-- PreLoader -->
              <v-overlay v-model="overlay" z-index="0">
                <lottie-player
                  src="https://assets5.lottiefiles.com/datafiles/XpFCWApEzLI29va/data.json"
                  background="transparent"
                  speed="1"
                  style="width: 300px; height: 300px"
                  loop
                  autoplay
                ></lottie-player>
              </v-overlay>
              <v-data-table
                :headers="headerProveedores"
                :items="proveedoresInternosExternos"
                :search="search"
              >
                <template v-slot:top>
                  <v-toolbar elevation="0">
                    <v-spacer></v-spacer>
                    <v-text-field
                      class="text-xs-center"
                      v-model="search"
                      append-icon="search"
                      label="Busqueda"
                      single-line
                      hide-details
                      outlined
                      dense
                    ></v-text-field>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-icon small class="mr-2" @click="verDetalles(item)">
                    tab
                  </v-icon>
                  <template v-if="item.estado">
                    <v-icon small @click="ActivarDesactivar(2, item)">
                      check
                    </v-icon>
                  </template>
                  <template v-else>
                    <v-icon small @click="ActivarDesactivar(1, item)">
                      block
                    </v-icon>
                  </template>
                </template>
                <template v-slot:[`item.estado`]="{ item }">
                  <v-chip :color="getColorCondicion(item.estado)" dark>
                    <div v-if="item.estado"><span>En alta</span></div>
                    <div v-else><span>De Baja</span></div>
                  </v-chip>
                </template>
              </v-data-table>
            </v-container>
          </v-tab-item>

          <v-tab-item>
            <v-container fluid class="pa-2">
              <v-data-table
                :headers="headerProveedores"
                :items="proveedoresGuatemala"
                :search="search"
              >
                <template v-slot:top>
                  <v-toolbar elevation="0">
                    <v-spacer></v-spacer>
                    <v-text-field
                      class="text-xs-center"
                      v-model="search"
                      append-icon="search"
                      label="Busqueda"
                      single-line
                      hide-details
                      outlined
                      dense
                    ></v-text-field>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-icon small class="mr-2" @click="verDetalles(item)">
                    tab
                  </v-icon>
                  <template v-if="item.estado">
                    <v-icon small @click="ActivarDesactivar(2, item)">
                      check
                    </v-icon>
                  </template>
                  <template v-else>
                    <v-icon small @click="ActivarDesactivar(1, item)">
                      block
                    </v-icon>
                  </template>
                </template>
                <template v-slot:[`item.estado`]="{ item }">
                  <v-chip :color="getColorCondicion(item.estado)" dark>
                    <div v-if="item.estado"><span>En alta</span></div>
                    <div v-else><span>De Baja</span></div>
                  </v-chip>
                </template>
              </v-data-table>
            </v-container>
          </v-tab-item>

          <v-tab-item>
            <v-container fluid class="pa-2">
              <v-data-table
                :headers="headerProveedores"
                :items="proveedoresHonduras"
                :search="search"
              >
                <template v-slot:top>
                  <v-toolbar elevation="0">
                    <v-spacer></v-spacer>
                    <v-text-field
                      class="text-xs-center"
                      v-model="search"
                      append-icon="search"
                      label="Busqueda"
                      single-line
                      hide-details
                      outlined
                      dense
                    ></v-text-field>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-icon small class="mr-2" @click="verDetalles(item)">
                    tab
                  </v-icon>
                  <template v-if="item.estado">
                    <v-icon small @click="ActivarDesactivar(2, item)">
                      check
                    </v-icon>
                  </template>
                  <template v-else>
                    <v-icon small @click="ActivarDesactivar(1, item)">
                      block
                    </v-icon>
                  </template>
                </template>
                <template v-slot:[`item.estado`]="{ item }">
                  <v-chip :color="getColorCondicion(item.estado)" dark>
                    <div v-if="item.estado"><span>En alta</span></div>
                    <div v-else><span>De Baja</span></div>
                  </v-chip>
                </template>
              </v-data-table>
            </v-container>
          </v-tab-item>

          <v-tab-item>
            <v-container fluid class="pa-2">
              <v-data-table
                :headers="headerProveedores"
                :items="proveedoresNicaragua"
                :search="search"
              >
                <template v-slot:top>
                  <v-toolbar elevation="0">
                    <v-spacer></v-spacer>
                    <v-text-field
                      class="text-xs-center"
                      v-model="search"
                      append-icon="search"
                      label="Busqueda"
                      single-line
                      hide-details
                      outlined
                      dense
                    ></v-text-field>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-icon small class="mr-2" @click="verDetalles(item)">
                    tab
                  </v-icon>
                  <template v-if="item.estado">
                    <v-icon small @click="ActivarDesactivar(2, item)">
                      check
                    </v-icon>
                  </template>
                  <template v-else>
                    <v-icon small @click="ActivarDesactivar(1, item)">
                      block
                    </v-icon>
                  </template>
                </template>
                <template v-slot:[`item.estado`]="{ item }">
                  <v-chip :color="getColorCondicion(item.estado)" dark>
                    <div v-if="item.estado"><span>En alta</span></div>
                    <div v-else><span>De Baja</span></div>
                  </v-chip>
                </template>
              </v-data-table>
            </v-container>
          </v-tab-item>

          <v-tab-item>
            <v-container fluid class="pa-2">
              <v-data-table
                :headers="headerProveedores"
                :items="proveedoresCostaRica"
                :search="search"
              >
                <template v-slot:top>
                  <v-toolbar elevation="0">
                    <v-spacer></v-spacer>
                    <v-text-field
                      class="text-xs-center"
                      v-model="search"
                      append-icon="search"
                      label="Busqueda"
                      single-line
                      hide-details
                      outlined
                      dense
                    ></v-text-field>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-icon small class="mr-2" @click="verDetalles(item)">
                    tab
                  </v-icon>
                  <template v-if="item.estado">
                    <v-icon small @click="ActivarDesactivar(2, item)">
                      check
                    </v-icon>
                  </template>
                  <template v-else>
                    <v-icon small @click="ActivarDesactivar(1, item)">
                      block
                    </v-icon>
                  </template>
                </template>
                <template v-slot:[`item.estado`]="{ item }">
                  <v-chip :color="getColorCondicion(item.estado)" dark>
                    <div v-if="item.estado"><span>En alta</span></div>
                    <div v-else><span>De Baja</span></div>
                  </v-chip>
                </template>
              </v-data-table>
            </v-container>
          </v-tab-item>

          <v-tab-item>
            <v-container fluid class="pa-2">
              <v-data-table
                :headers="headerProveedores"
                :items="proveedoresPanama"
                :search="search"
              >
                <template v-slot:top>
                  <v-toolbar elevation="0">
                    <v-spacer></v-spacer>
                    <v-text-field
                      class="text-xs-center"
                      v-model="search"
                      append-icon="search"
                      label="Busqueda"
                      single-line
                      hide-details
                      outlined
                      dense
                    ></v-text-field>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-icon small class="mr-2" @click="verDetalles(item)">
                    tab
                  </v-icon>
                  <template v-if="item.estado">
                    <v-icon small @click="ActivarDesactivar(2, item)">
                      check
                    </v-icon>
                  </template>
                  <template v-else>
                    <v-icon small @click="ActivarDesactivar(1, item)">
                      block
                    </v-icon>
                  </template>
                </template>
                <template v-slot:[`item.estado`]="{ item }">
                  <v-chip :color="getColorCondicion(item.estado)" dark>
                    <div v-if="item.estado"><span>En alta</span></div>
                    <div v-else><span>De Baja</span></div>
                  </v-chip>
                </template>
              </v-data-table>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </v-card>
      <!--Dialog para ver, actualizar y nuevo proveedor -->
      <v-dialog v-model="dialog" max-width="1000" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">Detalles</span>
            <v-spacer></v-spacer>
            <v-checkbox
              v-model="proveedor_nacional"
              label="Nacional"
            ></v-checkbox>
          </v-card-title>

          <v-card-text>
            <v-container fluid>
              <v-row>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="tipoProveedor"
                    :items="itemTipoProveedor"
                    label="TIPO PROVEEDOR"
                    hide-details
                    clearable
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  class="d-flex justify-space-around"
                  v-if="tipoProveedor == 'ASESORES INTERNOS Y EXTERNOS'"
                >
                  <v-switch
                    v-model="esAjustadorInterno"
                    inset
                    class="pt-0 mt-2"
                    color="primary"
                    label="Ajustador Interno"
                  ></v-switch>
                  <v-switch
                    v-model="esMotoSisa"
                    inset
                    class="pt-0 mt-2"
                    color="primary"
                    :disabled="!esAjustadorInterno"
                    label="Moto SISA"
                  ></v-switch>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="descripcion"
                    label="DESCRIPCION"
                    hide-details
                    clearable
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="nombre"
                    label="NOMBRE"
                    hide-details
                    clearable
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="telefono"
                    label="TELEFONO"
                    hide-details
                    clearable
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="direccion"
                    label="DIRECCION"
                    hide-details
                    clearable
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="dui"
                    label="DUI"
                    hide-details
                    clearable
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="ncr"
                    label="NRC"
                    hide-details
                    clearable
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="chatIdTelegram"
                    label="IDENTIFICADOR CHAT TELEGRAM"
                    hide-details
                    clearable
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="correo"
                    label="CORREO"
                    outlined
                    dense
                    hide-details
                    clearable
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-card class="elevation-1" outlined>
                    <v-card-title class="subtitle-1 font-weight-bold py-0 pt-3">
                      No Aplicar Renta En:
                    </v-card-title>

                    <v-card-text class="py-0 pb-3">
                      <v-row>
                        <v-col
                          v-for="option in options"
                          :key="option.label"
                          cols="6"
                          sm="3"
                          class="py-0"
                        >
                          <v-checkbox
                            v-model="option.value"
                            :label="option.label"
                            color="primary"
                            class="ma-0"
                            hide-details
                            :indeterminate="option.value == null"
                          >
                            <template v-slot:label>
                              <span class="subtitle-2 font-weight-medium">{{
                                option.label
                              }}</span>
                            </template>
                          </v-checkbox>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="razonSocial"
                    label="RAZON SOCIAL"
                    hide-details
                    clearable
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="nombre_banco"
                    label="NOMBRE BANCO"
                    hide-details
                    clearable
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="numero_cuenta"
                    label="N° CUENTA"
                    hide-details
                    clearable
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions class="px-6 pb-6">
            <v-tooltip right color="success">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="success"
                  v-bind="attrs"
                  v-on="on"
                  @click="openCostosProveedor"
                  >Costos
                  <v-icon right dark class="ml-1">
                    fas fa-dollar-sign
                  </v-icon></v-btn
                >
              </template>
              <span>Ver Detalle de Costos</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-btn color="primary" outlined @click="closeDialog()"
              >CANCELAR</v-btn
            >
            <v-btn color="primary" v-if="nuevo == 1" @click="guardar()"
              >GUARDAR</v-btn
            >
            <v-btn color="primary" v-if="nuevo == 0" @click="actualizar()"
              >ACTUALIZAR</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--Dialog para dar de alta o baja a proveedor -->
      <v-dialog v-model="addModal" max-width="290px">
        <v-card>
          <v-card-title class="headline" v-if="addAccion == 1"
            >¿Dar de alta?</v-card-title
          >
          <v-card-title class="headline" v-if="addAccion == 2"
            >Dar de baja?</v-card-title
          >
          <v-card-text>
            Estas a punto de
            <span v-if="addAccion == 1">Dar de alta</span>
            <span v-if="addAccion == 2">Dar de baja</span>
            al proveedor {{ addProveedor }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="cancel" @click="ActivarDesactivarCerrar()">
              Cancelar
            </v-btn>
            <v-btn v-if="addAccion == 1" color="success" @click="activar()">
              Dar de alta
            </v-btn>
            <v-btn v-if="addAccion == 2" color="warning" @click="desactivar()">
              Dar de baja
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogTelegram" max-width="500px">
        <template v-for="(item, index) in datosBotTelegram">
          <v-card :key="item.chatId" tile>
            <v-card-subtitle class="title pb-0">
              Identificador del chat: {{ item.chatId }}
            </v-card-subtitle>
            <v-card-subtitle class="title pb-0">
              Nombre: {{ item.nombre }}
            </v-card-subtitle>
            <v-card-subtitle class="title pb-0">
              Apellido: {{ item.apellido }}
            </v-card-subtitle>
          </v-card>
          <v-divider
            v-if="index < datosBotTelegram.length - 1"
            :key="index"
          ></v-divider>
        </template>
        <v-row no-gutters>
          <v-col cols="12" md="6">
            <v-btn block color="primary" @click="eliminarActividadBot()"
              >Eliminar historial</v-btn
            >
          </v-col>
          <v-col cols="12" md="6">
            <v-btn block color="grey" dark @click="dialogTelegram = false"
              >Cerrar</v-btn
            >
          </v-col>
        </v-row>
      </v-dialog>

      <v-dialog v-model="dialogTelegramvacio" max-width="500">
        <v-card>
          <v-card-subtitle class="display-1 text-center">
            No hay actividad del Bot @asisRegional_bot
          </v-card-subtitle>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" dark @click="dialogTelegramvacio = false"
              >Cerrar</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogError" max-width="500">
        <v-card>
          <v-card-title>Hubo algún error.</v-card-title>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      options: {
        viales: { label: "Auxilios Viales", value: null },
        gruas: { label: "Grúas", value: null },
        ajustesLegales: { label: "Ajustes y Legales", value: null },
        partePolicial: { label: "Parte Policial", value: null },
      },
      esAjustadorInterno: null,
      esMotoSisa: null,
      search: "",
      dialog: false,
      proveedores: [],
      proveedoresInternosExternos: [],
      proveedoresGuatemala: [],
      proveedoresHonduras: [],
      proveedoresNicaragua: [],
      proveedoresCostaRica: [],
      proveedoresPanama: [],
      headerProveedores: [
        { text: "Opciones", align: "center", value: "action", sortable: false },
        {
          text: "Tipo de Proveedores",
          align: "start",
          sortable: true,
          value: "tipoProveedor",
        },
        {
          text: "Razon Social",
          value: "razonSocial",
          align: " d-none",
        },
        {
          text: "Dui",
          value: "dui",
          align: " d-none",
        },
        {
          text: "Correo",
          value: "correo",
          align: " d-none",
        },
        {
          text: "NCR",
          value: "NRC",
          align: " d-none",
        },
        {
          text: "Descripción",
          align: "start",
          sortable: true,
          value: "descripcion",
        },
        { text: "Nombre", align: "start", sortable: true, value: "nombre" },
        {
          text: "Telefonos",
          align: "start",
          sortable: true,
          value: "telefono",
        },
        { text: "Estado", align: "start", sortable: true, value: "estado" },
      ],
      idProveedor: "",
      tipoProveedor: "",
      descripcion: "",
      nombre: "",
      telefono: "",
      direccion: "",
      chatIdTelegram: "",
      correo: "",
      proveedor_nacional: false,
      razonSocial: "",
      dui: "",
      ncr: "",
      nombre_banco: "",
      numero_cuenta: "",
      itemTipoProveedor: [
        "ASESORES INTERNOS Y EXTERNOS",
        "PROVEEDORES GUATEMALA",
        "PROVEEDORES HONDURAS",
        "PROVEEDORES NICARAGUA",
        "PROVEEDORES COSTA RICA",
        "PROVEEDORES PANAMA",
      ],
      nuevo: 0,
      addModal: 0,
      addAccion: 0,
      addProveedor: "",
      addId: "",
      overlay: false,
      //variables de telegram
      dialogTelegram: false,
      dialogTelegramvacio: false,
      token: "5024387664:AAGrXKGayYOFsALSYEYkHseAPe2TgZbFjF4",
      datosBotTelegram: [],
      update_id: 0,
      contador: 0,
      dialogError: false,
      dialogEnviado: false,
    };
  },
  watch: {
    esAjustadorInterno(val) {
      if (!val) {
        this.esMotoSisa = null;
      }
    },
  },
  created() {
    this.listar();
  },
  methods: {
    openCostosProveedor() {
      if (this.idProveedor) {
        const routeData = this.$router.resolve({
          path: `CostosProveedores/${this.idProveedor}`,
        });
        window.open(routeData.href, "_blank");
      }
    },
    eliminarActividadBot() {
      axios
        .post(
          "https://api.telegram.org/bot" +
            this.token +
            "/getUpdates?offset=" +
            this.update_id
        )
        .then((response) => {
          console.log("Historial eliminado", response.status);
          this.dialogTelegram = false;
          this.dialogTelegramvacio = true;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    obtenerDatosTelegram() {
      this.datosBotTelegram = [];
      axios
        .post("https://api.telegram.org/bot" + this.token + "/getUpdates")
        .then((response) => {
          if (response.data.result.length != 0) {
            this.dialogTelegram = true;
            for (var i = 0; i < response.data.result.length; i++) {
              var updateId = response.data.result[i].update_id;
              var object = response.data.result[i];
              if (object.hasOwnProperty("message")) {
                this.datosBotTelegram.push({
                  chatId: response.data.result[i].message.chat.id,
                  nombre: response.data.result[i].message.chat.first_name,
                  apellido: response.data.result[i].message.chat.last_name,
                });
              }
            }
            this.update_id = updateId + 1;
          } else {
            this.dialogTelegramvacio = true;
          }
        })
        .catch(function (error) {
          console.log("error", error);
        });
    },
    closeDialog() {
      this.dialog = false;
      this.limpiar();
    },
    dialogNuevo() {
      this.dialog = true;
      this.nuevo = 1;
    },
    getColorCondicion(condicion) {
      if (condicion == true) {
        return "green";
      } else {
        return "red";
      }
    },
    ActivarDesactivar(accion, item) {
      this.addModal = 1;
      this.addProveedor = item.nombre;
      this.addId = item.idProveedor;
      if (accion == 1) {
        this.addAccion = 1;
      } else if (accion == 2) {
        this.addAccion = 2;
      } else {
        this.addModal = 0;
      }
    },
    ActivarDesactivarCerrar() {
      this.addModal = 0;
    },
    activar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put("api/DetallexProveedores/Activar/" + this.addId, {}, configuracion)
        .then(function (response) {
          me.addModal = 0;
          me.addAccion = 0;
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    desactivar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .put(
          "api/DetallexProveedores/Desactivar/" + this.addId,
          {},
          configuracion
        )
        .then(function (response) {
          me.addModal = 0;
          me.addAccion = 0;
          me.listar();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    listar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.overlay = true;
      me.proveedores = [];
      axios
        .get("api/DetallexProveedores/Listar", configuracion)
        .then(function (response) {
          me.proveedores = response.data;
          me.splitProveedores(me.proveedores);
          if (response.status == 200) {
            me.overlay = false;
          }
        })
        .catch(function (error) {
          console.log(error);
          me.overlay = false;
        });
    },
    splitProveedores(data = []) {
      this.proveedoresInternosExternos = [];
      this.proveedoresGuatemala = [];
      this.proveedoresHonduras = [];
      this.proveedoresNicaragua = [];
      this.proveedoresCostaRica = [];
      for (var i = 0; i < data.length; i++) {
        const tipo = data[i].tipoProveedor;
        switch (tipo) {
          case "ASESORES INTERNOS Y EXTERNOS":
            this.proveedoresInternosExternos.push({
              idProveedor: data[i].idProveedor,
              tipoProveedor: data[i].tipoProveedor,
              descripcion: data[i].descripcion,
              nombre: data[i].nombre,
              telefono: data[i].telefono,
              direccion: data[i].direccion,
              estado: data[i].estado,
              chatIdTelegram: data[i].chatIdTelegram,
              dui: data[i].dui,
              ncr: data[i].ncr,
              razonSocial: data[i].razonSocial,
              nombre_banco: data[i].nombre_banco,
              numero_cuenta: data[i].numero_cuenta,
              nacional: data[i].nacional,
              correo: data[i].correo,
              motoSisa: data[i].motoSisa,
              ajustadorInterno: data[i].ajustadorInterno,
              noRentaViales: data[i].noRentaViales,
              noRentaGruas: data[i].noRentaGruas,
              noRentaLegalesAjustes: data[i].noRentaLegalesAjustes,
              noRentaPartes: data[i].noRentaPartes,
            });
            break;
          case "PROVEEDORES GUATEMALA":
            this.proveedoresGuatemala.push({
              idProveedor: data[i].idProveedor,
              tipoProveedor: data[i].tipoProveedor,
              descripcion: data[i].descripcion,
              nombre: data[i].nombre,
              telefono: data[i].telefono,
              direccion: data[i].direccion,
              estado: data[i].estado,
              chatIdTelegram: data[i].chatIdTelegram,
              dui: data[i].dui,
              ncr: data[i].ncr,
              razonSocial: data[i].razonSocial,
              nombre_banco: data[i].nombre_banco,
              numero_cuenta: data[i].numero_cuenta,
              nacional: data[i].nacional,
              correo: data[i].correo,
              noRentaViales: data[i].noRentaViales,
              noRentaGruas: data[i].noRentaGruas,
              noRentaLegalesAjustes: data[i].noRentaLegalesAjustes,
              noRentaPartes: data[i].noRentaPartes,
            });
            break;
          case "PROVEEDORES HONDURAS":
            this.proveedoresHonduras.push({
              idProveedor: data[i].idProveedor,
              tipoProveedor: data[i].tipoProveedor,
              descripcion: data[i].descripcion,
              nombre: data[i].nombre,
              telefono: data[i].telefono,
              direccion: data[i].direccion,
              estado: data[i].estado,
              chatIdTelegram: data[i].chatIdTelegram,
              dui: data[i].dui,
              ncr: data[i].ncr,
              razonSocial: data[i].razonSocial,
              nombre_banco: data[i].nombre_banco,
              numero_cuenta: data[i].numero_cuenta,
              nacional: data[i].nacional,
              correo: data[i].correo,
              noRentaViales: data[i].noRentaViales,
              noRentaGruas: data[i].noRentaGruas,
              noRentaLegalesAjustes: data[i].noRentaLegalesAjustes,
              noRentaPartes: data[i].noRentaPartes,
            });
            break;
          case "PROVEEDORES NICARAGUA":
            this.proveedoresNicaragua.push({
              idProveedor: data[i].idProveedor,
              tipoProveedor: data[i].tipoProveedor,
              descripcion: data[i].descripcion,
              nombre: data[i].nombre,
              telefono: data[i].telefono,
              direccion: data[i].direccion,
              estado: data[i].estado,
              chatIdTelegram: data[i].chatIdTelegram,
              dui: data[i].dui,
              ncr: data[i].ncr,
              razonSocial: data[i].razonSocial,
              nombre_banco: data[i].nombre_banco,
              numero_cuenta: data[i].numero_cuenta,
              nacional: data[i].nacional,
              correo: data[i].correo,
              noRentaViales: data[i].noRentaViales,
              noRentaGruas: data[i].noRentaGruas,
              noRentaLegalesAjustes: data[i].noRentaLegalesAjustes,
              noRentaPartes: data[i].noRentaPartes,
            });
            break;
          case "PROVEEDORES COSTA RICA":
            this.proveedoresCostaRica.push({
              idProveedor: data[i].idProveedor,
              tipoProveedor: data[i].tipoProveedor,
              descripcion: data[i].descripcion,
              nombre: data[i].nombre,
              telefono: data[i].telefono,
              direccion: data[i].direccion,
              estado: data[i].estado,
              chatIdTelegram: data[i].chatIdTelegram,
              dui: data[i].dui,
              ncr: data[i].ncr,
              razonSocial: data[i].razonSocial,
              nombre_banco: data[i].nombre_banco,
              numero_cuenta: data[i].numero_cuenta,
              nacional: data[i].nacional,
              correo: data[i].correo,
              noRentaViales: data[i].noRentaViales,
              noRentaGruas: data[i].noRentaGruas,
              noRentaLegalesAjustes: data[i].noRentaLegalesAjustes,
              noRentaPartes: data[i].noRentaPartes,
            });
            break;
          case "PROVEEDORES PANAMA":
            this.proveedoresPanama.push({
              idProveedor: data[i].idProveedor,
              tipoProveedor: data[i].tipoProveedor,
              descripcion: data[i].descripcion,
              nombre: data[i].nombre,
              telefono: data[i].telefono,
              direccion: data[i].direccion,
              estado: data[i].estado,
              chatIdTelegram: data[i].chatIdTelegram,
              dui: data[i].dui,
              ncr: data[i].ncr,
              razonSocial: data[i].razonSocial,
              nombre_banco: data[i].nombre_banco,
              numero_cuenta: data[i].numero_cuenta,
              nacional: data[i].nacional,
              correo: data[i].correo,
              noRentaViales: data[i].noRentaViales,
              noRentaGruas: data[i].noRentaGruas,
              noRentaLegalesAjustes: data[i].noRentaLegalesAjustes,
              noRentaPartes: data[i].noRentaPartes,
            });
            break;
        }
      }
    },
    verDetalles(item) {
      this.dialog = true;
      this.nuevo = 0;
      this.limpiar();
      this.idProveedor = item.idProveedor;
      this.tipoProveedor = item.tipoProveedor;
      this.descripcion = item.descripcion;
      this.nombre = item.nombre;
      this.telefono = item.telefono;
      this.direccion = item.direccion;
      this.estado = item.estado;
      this.chatIdTelegram = item.chatIdTelegram;
      this.dui = item.dui;
      this.ncr = item.ncr;
      this.razonSocial = item.razonSocial;
      this.nombre_banco = item.nombre_banco;
      this.numero_cuenta = item.numero_cuenta;
      this.proveedor_nacional = item.nacional;
      this.correo = item.correo;
      this.esAjustadorInterno =
        item.ajustadorInterno == null ? null : item.ajustadorInterno;
      this.esMotoSisa = item.motoSisa == null ? null : item.motoSisa;

      this.options.viales.value = item.noRentaViales;
      this.options.gruas.value = item.noRentaGruas;
      this.options.ajustesLegales.value = item.noRentaLegalesAjustes;
      this.options.partePolicial.value = item.noRentaPartes;
    },
    limpiar() {
      this.esAjustadorInterno = null;
      this.esMotoSisa = null;
      this.idProveedor = "";
      this.tipoProveedor = "";
      this.descripcion = "";
      this.nombre = "";
      this.telefono = "";
      this.direccion = "";
      this.estado = false;
      this.chatIdTelegram = "";
      this.dui = "";
      this.ncr = "";
      this.razonSocial = "";
      this.nombre_banco = "";
      this.numero_cuenta = "";
      this.proveedor_nacional = false;
      this.correo = "";

      this.options.viales.value = null;
      this.options.gruas.value = null;
      this.options.ajustesLegales.value = null;
      this.options.partePolicial.value = null;
    },
    guardar() {
      this.dialog = false;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      axios
        .post(
          "api/DetallexProveedores/Crear",
          {
            tipoProveedor: me.tipoProveedor,
            descripcion: me.descripcion,
            nombre: me.nombre,
            telefono: me.telefono,
            direccion: me.direccion,
            estado: true,
            chatIdTelegram: me.chatIdTelegram,
            dui: me.dui,
            ncr: me.ncr,
            razonSocial: me.razonSocial,
            nombre_banco: me.nombre_banco,
            numero_cuenta: me.numero_cuenta,
            nacional: me.proveedor_nacional,
            correo: me.correo,
            motoSisa: this.esMotoSisa,
            ajustadorInterno: this.esAjustadorInterno,
            noRentaViales: this.options.viales.value,
            noRentaGruas: this.options.gruas.value,
            noRentaLegalesAjustes: this.options.ajustesLegales.value,
            noRentaPartes: this.options.partePolicial.value,
          },
          configuracion
        )
        .then(function () {
          me.closeDialog();
          me.listar();
        })
        .catch(function () {
          //
        });
    },
    actualizar() {
      this.dialog = false;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      let me = this;
      axios
        .put(
          "api/DetallexProveedores/Actualizar",
          {
            idProveedor: me.idProveedor,
            tipoProveedor: me.tipoProveedor,
            descripcion: me.descripcion,
            nombre: me.nombre,
            telefono: me.telefono,
            direccion: me.direccion,
            estado: me.estado,
            chatIdTelegram: me.chatIdTelegram,
            dui: me.dui,
            ncr: me.ncr,
            razonSocial: me.razonSocial,
            nombre_banco: me.nombre_banco,
            numero_cuenta: me.numero_cuenta,
            nacional: me.proveedor_nacional,
            correo: me.correo,
            motoSisa: this.esMotoSisa,
            ajustadorInterno: this.esAjustadorInterno,
            noRentaViales: this.options.viales.value,
            noRentaGruas: this.options.gruas.value,
            noRentaLegalesAjustes: this.options.ajustesLegales.value,
            noRentaPartes: this.options.partePolicial.value,
          },
          configuracion
        )
        .then(function () {
          me.closeDialog();
          me.listar();
        })
        .catch(function () {
          me.dialogError = true;
        });
    },
  },
};
</script>